import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import Innerwrapper from '../inner-wrapper/Innerwrapper';
import { useGet } from "app/services/http-service";
import useAlertConfig from "app/hooks/useAlertConfig";
import Alert from "../alert/Alert";
import {
  GET_COMPLAINT_DETAILS,
  TRANSACTION_DETAILS_BY_ID
} from "app/api/ApiEndpoints";
import CopyToClipboard from 'react-copy-to-clipboard';
import { Initial } from 'react-initial';
import dayjs from 'dayjs';
import clsx from "clsx";
import Button from "app/components/button/Button";
import { useMutation } from "react-query";
import { saveAs } from "file-saver";
import "../../pages/panel/panel.css";
import "../../components/card/card.css";
import { useHistory } from 'react-router-dom';
import ImageLogo from "../../../images/assured.png";


function ComplaintDetails(props) {
  const id = props?.match?.params?.id;
  const authToken = localStorage.getItem("tspAuthToken");
  const { alertConfig, showFailureAlert } = useAlertConfig(6);
  const [isCopied, setIsCopied] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(true);
  const history = useHistory();



  const { data: complaintDetailsById } = useQuery("complaintDetailsById", () =>
    useGet({ url: `${GET_COMPLAINT_DETAILS}/${id}`, token: authToken }),
    {
      cacheTime : 1,
      onError: (error) => {
        showFailureAlert(error.message ? error.message : "Something went wrong");
      }
    }
  );
  const { data: transactionDetailsData } = useQuery("transactionDetails", () =>
    useGet({ url: `${TRANSACTION_DETAILS_BY_ID}/${id}`, token: authToken }),
    {
      cacheTime : 1,
      onError: (error) => {
        showFailureAlert(error.message ? error.message : "Something went wrong");
      }
    }
  );

  const {
    mutate: downloadTransactions,
    data: downloadTransactionData,
    isSuccess: fileDownloadedSucccfully,
  } = useMutation((data) => useGet(data), {
    onError: (error) => {
      showFailureAlert(error.message ? error.message : "Something went wrong");
    }
  });

  useEffect(() => {
    if (downloadTransactionData && fileDownloadedSucccfully) {
      const blob = new Blob([downloadTransactionData], {
        type: "application/pdf",
      });
      saveAs(blob, "transaction.pdf");
    }
  }, [downloadTransactionData]);



  return (
    <Innerwrapper>
      {alertConfig && (
        <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
      )}
      <h2>Complaint-Details</h2>
      <div className="transaction-panel row align-items-center justify-content-center">
        <div className="container shadow">
          <div className="row">
            <div className="col-md-4 p-0">
              <div className="card card_left p-4 background-success border-0">
                {
                  transactionDetailsData?.amount &&
                  <div className="pay_info">
                    <label>Amount</label>
                    <h2>₹ {transactionDetailsData?.amount}</h2>
                  </div>
                }
                {
                  <div className="pay_info">
                    <label>Bharat Connect Transaction ID</label>
                    <div className="d-flex">
                      <p>{transactionDetailsData?.txnId}</p>
                      <CopyToClipboard
                        text={transactionDetailsData?.txnId}
                        onCopy={() => setIsCopied(true)}
                      >
                        <i className="material-icons ml-2">content_copy</i>
                      </CopyToClipboard>
                      {isCopied ? (
                        <p>
                          <label className="ml-2">Copied</label>
                        </p>
                      ) : null}
                    </div>
                  </div>
                }
                {
                  transactionDetailsData && transactionDetailsData?.customerParams.map((param, index) => (
                    <div className="pay_info" key={index}>
                      <label>{param?.paramName}</label>
                      <p> {param?.value} </p>
                    </div>
                  ))
                }
              </div>
            </div>
            <div className="col-md-8 p-0 bg-white">
              <div className="card card_right ">
              <div className="text-right">
                  <img src={ImageLogo} alt="payulogo" width="80" />
                </div>
                <div className="status">
                  <div className="d-flex justify-content-center align-items-center pb-2">
                    <div className="mr-1 align-self-center">
                      {
                        transactionDetailsData && transactionDetailsData?.billerLogoURL ? (
                          <img
                            src={transactionDetailsData?.billerLogoURL}
                            alt="payulogo"
                            width="60"
                            className="pr-2"
                          />
                        ) : (
                          <div className="initial-circle cursor-default border-primary">
                            <Initial name={transactionDetailsData?.billerName} charCount={2} fontSize={20} fontWeight={600} height={55} width={55} />
                          </div>
                        )
                      }
                    </div>
                    <div>
                      {
                        transactionDetailsData?.billNickName && (
                          <p className="font-weight-bold text-left font_22 text-black">
                            {transactionDetailsData?.billNickName}
                          </p>
                        )
                      }
                      {
                        transactionDetailsData?.billerName && (
                          <p className="font-weight-bold darkgrey font_20">
                            {transactionDetailsData?.billerName}
                          </p>
                        )
                      }
                    </div>
                  </div>
                  <div className=" d_flex d-flex align-item-center justify-content-between justify_content_between mb-4 ">
                    {
                      transactionDetailsData?.status === "SUCCESS" && (
                        <div className="completed_box border-primary rounded p_2 mb-2">
                          <i className="material-icons text-success mr-5">
                            check_circle
                          </i>
                          <span className="text-success mr-5 font-weight-bold">
                            Completed
                          </span>
                          {
                            transactionDetailsData?.paymentDate && (
                              <span className="font-weight-light">
                                - {dayjs(transactionDetailsData?.paymentDate).format(
                                  "DD/MM/YYYY",
                                )}
                              </span>
                            )
                          }
                        </div>
                      )
                    }
                    {
                      (transactionDetailsData?.status === "PENDING" || transactionDetailsData?.status === "HOLD") && (
                        <div className="completed_box border-primary rounded p_2">
                          <i className="material-icons text-orange mr-5">
                            error_outline
                          </i>
                          <span className="text-orange mr-5 font-weight-bold">
                            {transactionDetailsData?.status} -
                          </span>
                          <span className="font-weight-light">
                            {dayjs(transactionDetailsData?.paymentDate).format(
                              "DD/MM/YYYY",
                            )}
                          </span>
                        </div>
                      )
                    }
                    {
                      (transactionDetailsData?.status === "CANCELLED" || transactionDetailsData?.status === "FAILURE") && (
                        <div>
                          <div className="completed_box border-primary rounded p_2">
                            <i className="material-icons text-orange mr-5">
                              error
                            </i>
                            <span className="text-orange mr-5 font-weight-bold">
                              {transactionDetailsData?.status} -
                            </span>
                            <span className="font-weight-light">
                              {dayjs(transactionDetailsData?.paymentDate).format(
                                "DD/MM/YYYY",
                              )}
                            </span>
                          </div>
                          {
                            transactionDetailsData?.errorMessage && (
                              <p className="font_14 text-danger">
                                {
                                  transactionDetailsData?.errorMessage
                                }
                              </p>
                            )
                          }

                        </div>
                      )
                    }

                    <div
                      className="completed_box btn-primary-outline p_2"
                      onClick={() => {
                        setIsExpanded(!isExpanded);
                      }}
                    >
                      <span className="text-black">
                        {isExpanded ? "Hide" : "View"} Details
                      </span>
                      <i className="material-icons text-black">
                        {isExpanded
                          ? "keyboard_arrow_right"
                          : "keyboard_arrow_down"}
                      </i>
                    </div>
                  </div>
                  <div className=' d_flex d-flex justify-content-between dashed-border-top text-align-left justify_content_between'>
                    <div className="info-group w-100">
                      <label >Complaint Id</label>
                      <p>{complaintDetailsById?.payload[0].complainId}</p>
                    </div>
                    <div className="info-group w-100">
                      <label >Complaint Date</label>
                      <p>{dayjs(complaintDetailsById?.payload[0].complaintDate).format(
                                "DD/MM/YYYY",
                              )}</p>
                    </div>
                    {
                      complaintDetailsById?.payload[0].complaintStatus === "UNRESOLVED" || complaintDetailsById?.payload[0].complaintStatus === "FAILURE" ? (
                        <button
                      type="button"
                      className={clsx(
                        "status",
                        "status-open w-35",
                      )}
                    >
                      {complaintDetailsById?.payload[0].complaintStatus}
                    </button>
                      ) :  complaintDetailsById?.payload[0].complaintStatus === "RESOLVED" || complaintDetailsById?.payload[0].complaintStatus === "SUCCESS" ? (
                        <button
                      type="button"
                      className={clsx(
                        "status",
                        "status-resolved",
                      )}
                        >
                          {complaintDetailsById?.payload[0].complaintStatus}
                        </button>
                      ) : (
                          <button
                            type="button"
                            className={clsx(
                              "status",
                              "status-hold",
                            )}
                          >
                            {complaintDetailsById?.payload[0].complaintStatus}
                          </button>
                      )
                    }
                    
                  </div>
                  {isExpanded && (
                    <>
                      <div className="card bg-info p-2 text-left">
                        <div className=" align-items-center summary-card">

                          <div className="info-group">
                            <label >Issue :</label>
                            <p>{complaintDetailsById?.payload[0].disposition}</p>
                          </div>
                          {
                            complaintDetailsById?.payload[0].userComplaintMessage && (
                              <div className="info-group">
                                <label >Complain Message : </label>
                                <p>{complaintDetailsById?.payload[0].userComplaintMessage}</p>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </>
                  )}
                  <div className="dotted-border-primary"></div>
                  <div className="d-flex justify-content-between align-item-center font-weight-light my-4">
                    <div
                      onClick={() => {
                        downloadTransactions({
                          url: `/tsp/bill-details/v1/api/transaction/${transactionDetailsData.txnId}/download?logoUrl=`,
                          responseType: "blob",
                          token: authToken,
                        });
                      }}
                    >
                      <span className="mr-1 mb-4"> Download</span>
                      <i className="material-icons" width="20">
                        download
                      </i>
                    </div>
                  </div>
                  <div onClick={() => history.push("/history?tab=2")} className="d-flex justify-content-center">
                    <Button className="btn-primary-outline col-md-3 ">
                      Done
                    </Button>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Innerwrapper>
  );
}

export default ComplaintDetails;